import { FeatureFlag } from '@revelio/core';

import { useUnleashFlag } from '../../../../shared/unleash-flags/use-unleash-flag';
import type {
  BreakdownSingleDataSet,
  SingleDataSet,
} from '../DataProvider/types';
import type { MetricValues } from '../PageConfigProvider/types/metric';
import { FlatTreeMap } from './FlatTreeMap';
import { NestedTreeMap } from './NestedTreeMap';

type TreeMapProps = {
  data: BreakdownSingleDataSet['data'] | SingleDataSet['data'];
  metric?: MetricValues;
};

/**
 * Treemap entry point used by the chart selector.
 *
 * The nested treemap (grouped rectangles, drilldown that fetches its initial
 * level through {@link NestedCompositionTreemapDrilldownProvider}, and the
 * extra parent-totals composition query) is only enabled under the
 * `DashboardNewLayout` flag, which is also what selects the V2 composition
 * pages. When the flag is off we preserve the legacy flat treemap, whose
 * initial level renders directly from the `data` prop (a single query) and
 * only drills via the legacy single-query provider after a click.
 */
export const TreeMap = ({ data, metric }: TreeMapProps) => {
  const isNewDashboardLayout = useUnleashFlag(FeatureFlag.DashboardNewLayout);

  return isNewDashboardLayout ? (
    <NestedTreeMap data={data} metric={metric} />
  ) : (
    <FlatTreeMap data={data} metric={metric} />
  );
};
